window.currentSelectedVariantID = null;
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    //console.log('got here - 8');
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    // debugger;
    if (!this.currentVariant || typeof this.currentVariant == 'undefined') {
      window.currentSelectedVariantID = null;
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      window.currentSelectedVariantID = this.currentVariant.id;
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.renderRezCustomBar();         
    }
    this.renderRezQuantityInfoBox();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        //console.log(this.currentVariant);
        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        $( `.product .price_box`).removeClass('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        let regularPrice = $('.product-popup .price__regular .price__last .price-item').text();
        let saleregularPrice = $('.product-popup .price__sale .price__last .price-item').text();
        let comparePrice = $('.product-popup .price__sale .price__compare .price-item').text();
        let savePrice = $('.product-popup .price__sale .save-price span').text();
        if($('.product-popup .price_box .price').hasClass('price--on-sale')){
          $('.product .price').addClass('price--on-sale');
        } else{
          $('.product .price').removeClass('price--on-sale');
        }
        $('.product .price .price__regular .price__last .price-item').text(regularPrice);
        $('.product .price .price__sale .price__last .price-item').text(saleregularPrice);
        $('.product .price .price__sale .price__compare .price-item').text(comparePrice);
        $('.product .price .price__sale .save-price span').text(savePrice);
      })
  }

  
  renderRezQuantityInfoBox() {
    if(window.currentSelectedVariantID == null) {
      $(".product__availability").fadeOut(0);
    } else {
      let invObject = window.variants[window.currentSelectedVariantID];
      if(invObject.inv_policy != "continue" && parseInt(invObject.inv_qty) > 0) {
        $(".inventory_data").html(invObject.inv_qty);
        $(".product__availability").fadeIn(100);
      } else {
        $(".product__availability").fadeOut(0);
      }
    }
  }
  renderRezCustomBar() {
    // debugger;
    if(typeof this.currentVariant.featured_image != 'undefined' && this.currentVariant.featured_image !== null ) {
      if(typeof this.currentVariant.featured_image.src != 'undefined' && this.currentVariant.featured_image.src !== null ) {
        let imageToUpdate = this.currentVariant.featured_image.src;
        imageToUpdate = imageToUpdate.replace('.jpg','_40x.jpg').replace('.png','_40x.png')
        $(`.product-popup .product_img > img`).attr('src',imageToUpdate);
      }
    }
    //console.log('testcomapre',$('.price__compare').find('.price-item--regular-compare').text());
    $('.price__regular .price-item--regular').text(Shopify.formatMoney(this.currentVariant.price, "${{amount}}"));
    $('[data-comapre-price]').text(Shopify.formatMoney(this.currentVariant.compare_at_price, "${{amount}}"));
    //$('[data-save-price]').text(Shopify.formatMoney((this.currentVariant.compare_at_price - this.currentVariant.price),"${{amount}}"));
    // console.log(this.currentVariant);
    // console.log('price=',Shopify.formatMoney(this.currentVariant.price));
    // console.log('compare_at_price=',Shopify.formatMoney(this.currentVariant.compare_at_price));
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
      if (text){
        $(`.product-popup [data-sticky-atc]`).text(text);
        $(`.product-popup [data-sticky-atc]`).attr('disabled','disabled');
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
      $(`.product-popup [data-sticky-atc]`).text(window.variantStrings.addToCart);
      $(`.product-popup [data-sticky-atc]`).removeAttr('disabled');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    $(`.product-popup [data-sticky-atc]`).text(window.variantStrings.unavailable);
    $(`.product-popup [data-sticky-atc]`).attr('disabled','disabled');
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    $( `.product .price_box`).addClass('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
